<template>
  <div>
    <el-dialog
        title="Đồng bộ thiết bị"
        :visible="showSynchronizeDeviceDialog"
        width="35%"
        @open="handleOpen"
        :before-close="handleClose">
      <el-form :model="dataForm" :rules="(loadingDevices || loadingButton || synchronizationRunning || restoringSyncJobs) ? {} : rules" :validate-on-rule-change="false" ref="ruleForm">
        <DeviceSynchronizationProgress
            :job="syncJob" :jobs="syncJobs" :error="trackingError" :loading="restoringSyncJobs"
            @select="selectSynchronizationJob" @refresh="refreshSynchronizationJobs()"
        />
        <el-form-item label="Thiết bị nguồn" prop="idDeviceOld">
          <el-select
              filterable
              clearable
              v-model="dataForm.idDeviceOld"
              placeholder="Chọn thiết bị nguồn"
              :loading="loadingDevices"
              :disabled="loadingDevices || loadingButton || synchronizationRunning || restoringSyncJobs"
              @change="handleSourceChange"
              style="width: 100%"
          >
            <el-option
                v-for="item in listIdDevice"
                :key="item.id"
                :value="item.id"
                :label="item.nameDevice"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Thiết bị đích" prop="idDeviceNew">
          <el-select
              filterable
              clearable
              v-model="dataForm.idDeviceNew"
              placeholder="Chọn thiết bị đích"
              :loading="loadingDevices"
              :disabled="loadingDevices || loadingButton || synchronizationRunning || restoringSyncJobs"
              style="width: 100%"
          >
            <el-option
                v-for="item in listIdDevice"
                :key="item.id"
                :value="item.id"
                :label="item.nameDevice"
                :disabled="item.id === dataForm.idDeviceOld"
            >
              <span>{{ item.nameDevice }}</span>
            </el-option>
          </el-select>
        </el-form-item>


      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="submitForm" :loading="loadingButton" :disabled="loadingDevices || restoringSyncJobs || synchronizationRunning || listIdDevice.length < 2">Áp dụng</el-button>
          <el-button @click="handleClose" type="danger" :disabled="loadingButton">Đóng</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import recognitionManagerService from "@/services/SchoolService/RecognitionManagerService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import DeviceSynchronizationProgress from "@/components/DeviceSynchronizationProgress.vue";
import { createDeviceSynchronizationTracker } from "@/utils/deviceSynchronization";

export default {
  name: "SynchronizeDeviceDialog",
  components: { DeviceSynchronizationProgress },
  mixins: [createDeviceSynchronizationTracker(recognitionManagerService, "school")],
  props: {
    showSynchronizeDeviceDialog: {
      type: Boolean,
      default: () => false
    },
    idDeviceOld: {
      type: Number,
      default: () => 0
    },
  },
  data() {
    return {
      listIdDevice: [],
      dataForm: {
        idDeviceOld: null,
        idDeviceNew: null
      },
      rules: {
        idDeviceOld: [
          { required: true, message: 'Chọn thiết bị nguồn!', trigger: 'change' }
        ],
        idDeviceNew: [
          { required: true, message: 'Chọn thiết bị đích!', trigger: 'change' }
        ]
      },
      loadingButton: false,
      loadingDevices: false,
      devicesRequestId: 0
    }
  },
  mounted() {
    if (this.showSynchronizeDeviceDialog && !this.loadingDevices) this.handleOpen();
  },
  methods: {
    onSynchronizationRecovered(job) {
      this.dataForm = { idDeviceOld: job.idDeviceOld, idDeviceNew: job.idDeviceNew };
      if (!this.showSynchronizeDeviceDialog) this.$emit("resume");
    },
    onSynchronizationAlreadyRunning() {
      NotifyMessage.leftCornerNotificationWarning("Thiết bị đích đang có một tác vụ đồng bộ. Đang hiển thị tiến trình hiện có, không tạo thêm lượt mới.");
    },
    onSynchronizationFinished(job) {
      const message = job.message || "Đã kết thúc lượt đồng bộ";
      if (job.status === "SUCCEEDED") NotifyMessage.leftCornerNotificationSuccess(message);
      else if (job.status === "COMPLETED_WITH_WARNINGS" || job.status === "PARTIAL") NotifyMessage.leftCornerNotificationWarning(message);
      else NotifyMessage.leftCornerNotificationError(message);
      this.$emit("synchronized");
    },

    handleClose() {
      if (this.loadingButton) return;
      this.devicesRequestId++;
      this.loadingDevices = false;
      this.dismissSynchronizationResult();
      this.$emit('close');
      this.listIdDevice = [];
    },

    async handleOpen() {
      const requestId = ++this.devicesRequestId;
      this.listIdDevice = [];
      this.dataForm = this.syncJob
        ? { idDeviceOld: this.syncJob.idDeviceOld, idDeviceNew: this.syncJob.idDeviceNew }
        : { idDeviceOld: this.idDeviceOld || null, idDeviceNew: null };
      this.loadingDevices = true;
      this.$nextTick(() => {
        if (this.$refs.ruleForm) this.$refs.ruleForm.clearValidate();
      });
      try {
        const response = await recognitionManagerService.getListDeviceRecognition();
        if (requestId !== this.devicesRequestId || !this.showSynchronizeDeviceDialog) return;
        this.listIdDevice = response.data.data || [];
        if (!this.listIdDevice.some(item => item.id === this.dataForm.idDeviceOld)) {
          this.dataForm.idDeviceOld = null;
        }
      } catch (error) {
        if (requestId === this.devicesRequestId && this.showSynchronizeDeviceDialog) {
          console.log(error);
          NotifyMessage.leftCornerNotificationError("Không tải được danh sách thiết bị");
        }
      } finally {
        if (requestId === this.devicesRequestId) {
          this.loadingDevices = false;
          this.$nextTick(() => { if (requestId === this.devicesRequestId && this.$refs.ruleForm) this.$refs.ruleForm.clearValidate(); });
        }
      }
      if (requestId === this.devicesRequestId && this.showSynchronizeDeviceDialog) await this.refreshSynchronizationJobs(true);
    },
    handleSourceChange() {
      if (this.dataForm.idDeviceNew === this.dataForm.idDeviceOld) {
        this.dataForm.idDeviceNew = null;
      }
    },
    async submitForm() {
      if (this.loadingButton || this.loadingDevices || this.synchronizationRunning || this.restoringSyncJobs || !this.showSynchronizeDeviceDialog) return;
      const requestId = this.devicesRequestId;
      const valid = await this.$refs.ruleForm.validate().catch(() => false);
      if (!valid || this.loadingButton || this.loadingDevices || this.synchronizationRunning || this.restoringSyncJobs ||
          requestId !== this.devicesRequestId || !this.showSynchronizeDeviceDialog) return;
      const { idDeviceOld, idDeviceNew } = this.dataForm;
      if (idDeviceOld === idDeviceNew) {
        NotifyMessage.leftCornerNotificationWarning("Thiết bị nguồn và thiết bị đích phải khác nhau");
        return;
      }
      if (![idDeviceOld, idDeviceNew].every(id => this.listIdDevice.some(item => item.id === id))) {
        NotifyMessage.leftCornerNotificationWarning("Vui lòng chọn thiết bị trong danh sách của trường");
        return;
      }
      this.loadingButton = true;
      try {
        await this.startSynchronizationJob({ idDeviceOld, idDeviceNew });
      } catch (error) {
        console.log(error);
        if (error && error.synchronizationStartUncertain) NotifyMessage.leftCornerNotificationWarning(error.message);
        else NotifyMessage.leftCornerNotificationError(error?.response?.data?.message || "Không thể bắt đầu đồng bộ");
      } finally {
        this.loadingButton = false;
      }
    },
  }
};
</script>
<style lang="scss" scoped>

</style>
